let DEV_RESOURCE_HOST = '/policies'
let PROD_RESOURCE_HOST = 'https://trazolabs.sfo2.digitaloceanspaces.com/trazolabs/privacy-policies'

export const isDev = process.env.NODE_ENV === 'development'

export const baseResourceURL = isDev ? `${DEV_RESOURCE_HOST}/` : `${PROD_RESOURCE_HOST}/`
